import { Avatar, Select, Space } from "antd";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { manageOfficialStatuses as statuses } from "../../../utilities/constants";
import PersonList from "../../Person/PersonList";
import useOfficialRolesData, { officialRolesDataReturnType } from "../hooks/useOfficialRolesData";
import { SubmitCandidateButton } from "./SubmitCandidateButton";
import { findImageByTypes } from "~utilities/findImageByTypes.ts";
import { ImageSizes } from "~enums/imageSizes.ts";
import { ImageTypes } from "~enums/imageTypes.ts";
import ImageView from "../../../components/ImageView/ImageView.tsx";

const Candidates = (props) => {
  const { pageRef, roles: candidateRoles, refetch } = props;

  const { formatMessage } = useIntl();

  const params = useParams();
  const [roles, setRoles] = useState({});
  const [candidateStatuses, setCandidateStatuses] = useState({});
  const [isLoading, setIsLoading] = useState({});

  const candidateRolesSelectOptions = useOfficialRolesData(
    candidateRoles,
    formatMessage,
    officialRolesDataReturnType.SELECT_OPTIONS,
  );

  const setIsLoadingForPerson = (personId, val) =>
    setIsLoading({
      ...isLoading,
      [personId]: val,
    });

  const columns = [
    {
      title: formatMessage({
        id: "name.local.full",
        defaultMessage: "Local Full Name",
      }),
      dataIndex: "nameFullLocal",
      render: (value, row) => (
        <Space size="small">
          <ImageView
            imageUrl={findImageByTypes(row.images, [ImageTypes.PersonHead])?.url}
            size={ImageSizes.Small}
            width={25}
            height={25}
            imageType={ImageTypes.Logo}
          />
          {value}
        </Space>
      ),
    },
    {
      title: formatMessage({
        id: "role",
        defaultMessage: "Role",
      }),
      render: (value, row) => {
        return (
          <Select
            showSearch
            defaultActiveFirstOption={true}
            options={candidateRolesSelectOptions}
            style={{ width: 120 }}
            value={roles?.[row?.personId]}
            onChange={(val) => {
              setRoles({ ...roles, [row.personId]: val });
            }}
          />
        );
      },
    },
    {
      title: formatMessage({
        id: "status",
        defaultMessage: "Status",
      }),
      render: (value, row) => {
        return (
          <Select
            showSearch
            options={statuses.map((status) => ({
              value: status,
              label: formatMessage({
                id: `${status}`,
                defaultMessage: `${status}`,
              }),
            }))}
            style={{ width: 120 }}
            value={candidateStatuses[row.personId] || statuses[0]}
            onChange={(val) =>
              setCandidateStatuses({
                ...candidateStatuses,
                [row.personId]: val,
              })
            }
          />
        );
      },
    },
    {
      title: null,
      align: "right",
      render: (value, row) => (
        <SubmitCandidateButton
          person={row}
          role={roles[row.personId] || ""}
          status={candidateStatuses[row.personId] || statuses[0]}
          setIsLoadingForPerson={setIsLoadingForPerson}
          refetch={refetch}
          pageRef={pageRef}
          {...params}
        />
      ),
    },
  ];

  return <PersonList limit={10} columns={columns} />;
};

export default Candidates;
